import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import axios from '@/axios';
import global from '@/components/global.js';
import i18n from '@/locales';

import './utils/directive';

import ElementUI from 'irm-ui';
import 'irm-ui/lib/theme-chalk/index.css';

import 'swiper/swiper-bundle.css';

import '@/assets/iconfont/iconfont.css';
import '@/assets/iconfont/iconfont.js';
import '@/style/main.less';
import '@/utils/rem.js';

import vueHashCalendar from 'vue-hash-calendar';
import 'vue-hash-calendar/lib/vue-hash-calendar.css';
Vue.use(vueHashCalendar);

Vue.use(ElementUI, {
	i18n: (key, value) => i18n.t(key, value)
});
Vue.use(global);

import DialogComponent from '@/utils/modal.js';
Vue.use(DialogComponent, {
	router,
	store
});

import { isMac } from '@/const/host';
if (isMac) {
	document.body.classList.add('is-mac');
}

import { trackerInit } from '@/utils/track/index';
// 初始化阿里云SDK
trackerInit();

import { isMobile, isBuild } from '@/const/host';
if (isMobile && !isBuild) {
	let VConsole = require('vconsole');
	new VConsole();
}

Vue.config.productionTip = false;
Vue.prototype.$request = axios;

new Vue({
	router,
	store,
	i18n,
	render: h => h(App)
}).$mount('#app');
